"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeGeometryHellfix = exports.Gmetry = exports.Face3 = exports.DirectGeometry = void 0;
var DirectGeometry_1 = require("./DirectGeometry");
Object.defineProperty(exports, "DirectGeometry", { enumerable: true, get: function () { return DirectGeometry_1.DirectGeometry; } });
var Face3_1 = require("./Face3");
Object.defineProperty(exports, "Face3", { enumerable: true, get: function () { return Face3_1.Face3; } });
var Gmetry_1 = require("./Gmetry");
Object.defineProperty(exports, "Gmetry", { enumerable: true, get: function () { return Gmetry_1.Gmetry; } });
var mylibrary_1 = require("./mylibrary");
Object.defineProperty(exports, "ThreeGeometryHellfix", { enumerable: true, get: function () { return mylibrary_1.ThreeGeometryHellfix; } });
//# sourceMappingURL=index.js.map